<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="mt-4 pb-2">Quick start:</h2>
      </div>
      <div class="col-12">
        <div>1. Install engine via pip in your virtual environment:</div>
        <div class=" text-monospace mt-2 ml-4"><code>pip install pycrunch-engine</code></div>
        <div class="mt-5">2. Search for PyCrunch plugin in <a href="https://plugins.jetbrains.com/plugin/13264-pycrunch--live-testing" target="_blank">PyCharm Plugin Repository</a> and install it.</div>
        <div class="mt-2 ml-4 small">Alternatively, you can <a class="mt-0"
                                                         href="https://pycrunch-dist.s3.eu-central-1.amazonaws.com/pycrunch-intellij-connector-latest.zip"
                                                         target="_blank">download offline package</a> and install plugin
          from disk <span class="help__link" @click="install_from_disk_visible = true">(?)</span></div>


      </div>
      <div class="col-12">
        <div class="mt-5">3. Connect from PyCharm using top menu: <code>Tools->PyCrunch->Run/Restart PyCrunch
          Engine</code></div>
        <div class="mt-2 mb-5 ml-4 text-secondary small">
          <div>Note: This menu might not be visible until you restart JetBrains IDE or reopen your project.</div>
          <div>If you don't want to close IDE you can search for action <code>Run/Restart PyCrunch Engine</code> using Command+Shift+A or Ctrl+Shift+A on Windows</div>
        </div>

        <div class="mt-5">
          On the first run, configuration file
          <code>.pycrunch-config.yaml</code> will be created in the root of your project.
        </div>
        <div class="mt-2">Feel free to change it according to <router-link to="/docs/configuration-file/">the documentation</router-link> if you need Django Support or specific fine-tuning</div>


        <el-tabs class="mt-4 mb-5" v-model="activeTabName" @tab-click="handleTabClick">
          <el-tab-pane label="I'm using Pytest" name="pytest">

            <code style="white-space: pre-wrap; ">discovery:
  exclusions:
  # (example) do not search tests in 'ignored_folder' folder
  - ignored_folder/
  # do not search tests in 'test_ignored.py' file
  - test_ignored.py
engine:
  runtime: pytest
            </code>
          </el-tab-pane>
          <el-tab-pane label="I need Django support" name="django">
            <code style="white-space: pre-wrap; ">discovery:
  exclusions:
  # (example) do not search tests in 'ignored_folder' folder
  - ignored_folder/
  # do not search tests in 'test_ignored.py' file
  - test_ignored.py
engine:
  runtime: django
env:
  # everything here will be passed as environment variables to the test runner
  DJANGO_SETTINGS_MODULE: my_django_project.settings.local
  DJANGO_ALLOW_ASYNC_UNSAFE: "true"</code>
          </el-tab-pane>

        </el-tabs>

      </div>
    </div>
    <el-dialog
        title="How do I install from disk?"
        :visible.sync="install_from_disk_visible"
        width="90%">
      <div>In PyCharm, go to Preferences->Plugins.</div>
      <div>Select Install Plugin From Disk in popup.</div>
      <div> Select downloaded PyCrunch Connector Extension the file browser.</div>
      <div class="text-center">
        <img src="../../assets/pycharm_installation.jpg" style="width: 799px" class="img-fluid">
      </div>
      <div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="install_from_disk_visible = false">Got it</el-button>
  </span>
    </el-dialog>

  </div>
</template>
<script>
  import {track} from '../../ga-events'

  export default {
    name: 'pc-quick-start',
    data() {
      return {
        install_from_disk_visible: false,
        activeTabName: 'pytest',
      }
    },
    methods: {
      handleTabClick (tab, event) {
        track('home', 'framework_tab_click', this.activeTabName)
      },
    },
  }
</script>
<style scoped>

  .help__link {
    border-bottom: 1px dashed #007bff;
    cursor: pointer;
    color: #007bff;
  }

</style>